import { render, staticRenderFns } from "./BranchesMainView.vue?vue&type=template&id=e082860e&scoped=true&"
import script from "./BranchesMainView.vue?vue&type=script&lang=js&"
export * from "./BranchesMainView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e082860e",
  null
  
)

export default component.exports